/* ==========================================================================
   Cart drawer controller
   Listens for cart:open, cart:close, cart:updated events.
   Re-fetches cart JSON and rewrites the drawer body via section render API.
   ========================================================================== */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const trigger = document.querySelector('[data-cart-toggle]');
  const closeBtns = drawer.querySelectorAll('[data-cart-close]');
  const overlay = drawer.querySelector('.cart-drawer__overlay');
  const body = drawer.querySelector('[data-cart-body]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');

  const setOpen = (open) => {
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) drawer.removeAttribute('hidden');
    else setTimeout(() => drawer.setAttribute('hidden', ''), 350);
  };

  const open = () => setOpen(true);
  const close = () => setOpen(false);

  trigger?.addEventListener('click', (e) => { e.preventDefault(); open(); });
  overlay?.addEventListener('click', close);
  closeBtns.forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  window.addEventListener('cart:open', open);
  window.addEventListener('cart:close', close);

  const refresh = async () => {
    try {
      const [cartRes, sectionRes] = await Promise.all([
        fetch('/cart.js', { headers: { Accept: 'application/json' } }),
        fetch('?section_id=cart-drawer', { headers: { Accept: 'text/html' } }),
      ]);
      const cart = await cartRes.json();
      const html = await sectionRes.text();

      // Update count badges
      cartCountEls.forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      // Swap drawer inner
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newBody = parsed.querySelector('[data-cart-body]');
      const newFooter = parsed.querySelector('[data-cart-footer]');
      if (newBody && body) body.innerHTML = newBody.innerHTML;
      if (newFooter && footer) footer.innerHTML = newFooter.innerHTML;

      bindLineItems();
    } catch (e) {
      /* noop */
    }
  };

  const changeLine = async (key, quantity) => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    window.dispatchEvent(new CustomEvent('cart:updated'));
  };

  const bindLineItems = () => {
    drawer.querySelectorAll('[data-line-remove]').forEach((btn) => {
      btn.addEventListener('click', () => changeLine(btn.dataset.lineKey, 0));
    });
    drawer.querySelectorAll('[data-line-quantity]').forEach((input) => {
      input.addEventListener('change', () => changeLine(input.dataset.lineKey, Number(input.value)));
    });
    drawer.querySelectorAll('[data-line-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = Number(btn.dataset.lineStep) || 1;
        const input = drawer.querySelector(`[data-line-quantity][data-line-key="${btn.dataset.lineKey}"]`);
        if (!input) return;
        const next = Math.max(0, Number(input.value) + step);
        input.value = next;
        changeLine(btn.dataset.lineKey, next);
      });
    });
  };

  window.addEventListener('cart:updated', refresh);
  bindLineItems();
})();
